import React from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function NotFoundPage() {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <div className="flex flex-col items-center justify-center min-h-[70vh] px-4 py-8 bg-gray-50 dark:bg-gray-900">
      <div className="mb-8">
        {/* Big 404 Icon */}
        <svg width="128" height="128" fill="none" viewBox="0 0 128 128">
          <circle cx="64" cy="64" r="64" fill="#E0E7FF" />
          <text x="50%" y="54%" textAnchor="middle" fontSize="48" fill="#1D4ED8" fontWeight="bold" dy=".3em">404</text>
        </svg>
      </div>
      <h1 className="text-3xl font-bold mb-2 text-blue-700 dark:text-blue-300">
        {t("notFound.title")}
      </h1>
      <p className="text-gray-600 dark:text-gray-300 mb-6 text-center max-w-md">
        {t("notFound.desc").split("\n").map((str, i) => (
          <React.Fragment key={i}>
            {str}
            <br />
          </React.Fragment>
        ))}
      </p>
      <div className="flex gap-3">
        <button
          className="bg-blue-600 text-white px-5 py-2 rounded-lg font-semibold shadow hover:bg-blue-700 transition"
          onClick={() => navigate("/")}
        >
          {t("notFound.homeBtn")}
        </button>
        <button
          className="bg-gray-200 text-gray-700 px-5 py-2 rounded-lg font-semibold hover:bg-gray-300 transition"
          onClick={() => navigate(-1)}
        >
          {t("notFound.backBtn")}
        </button>
      </div>
    </div>
  );
}
